/**
 * ActivationPaymentsCommonSubscriptionCtrl controller
 */

import { remove, add, getId } from 'app/helpers/entity'
import CheckUncheckDevices from './checkUncheckDevices.class'
import { CONTENT_TYPES, MONETIZATION_TYPES, RENT_LENGTH_TYPES } from '../../../app/core/constants'

/**
 * ActivationPaymentsCommonSubscriptionCtrl controller
 *
 * @class ActivationPaymentsCommonSubscriptionCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationPaymentsCommonSubscriptionCtrl
 */
/* @ngInject */
export default function ActivationPaymentsCommonSubscriptionCtrl ($http, $uibModal, $scope, PaymentRequest, DeviceSlot, alertLiteSvc, authSvc, subscr, extra, scope, accessories) {
  const vm = this

  vm.priceTypes = MONETIZATION_TYPES
  vm.timeUnits = RENT_LENGTH_TYPES
  vm.contentTypes = CONTENT_TYPES

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Subscriber
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCommonSubscriptionCtrl
   * @type {models.Subscriber}
   */
  vm.subscr = subscr
  vm.showAdjustment = subscr.paymentStatements.filter(ps => ps.paymentType === 'Common_Subscription' && ps.status === 'ACTIVE').length < 2

  vm.maxSubscriptionLength = scope.settings.ACTIVATION_LENGTH_LIMIT

  /**
   * Extra
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCommonSubscriptionCtrl
   * @type {Object}
   */
  vm.extra = extra

  vm.proratingEnabled = vm.extra.networkSettings.SUBSCRIPTION_PRORATING_ENABLED === 'true'
  /**
   * Shared scope
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCommonSubscriptionCtrl
   * @type {Object}
   */
  vm.scope = scope

  /**
   * Return blank payment request
   * When user changes payment type, for exmple, we need new blank payment request, without old data
   *
   * @function
   */
  const getBlankPaymentRequest = (defaults = {}) => ({
    contentSetAddOns: [],
    addOns: [],
    devicesToPay: null,
    override: true,
    prorateSubscription: false,
    ...defaults
  })

  vm.freeSubscription = function () {
    return vm.subscription.free || vm.subscription.baseAmount.amount === 0
  }

  /**
   * Blank for PaymentRequest
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCommonSubscriptionCtrl
   * @type {Object}
   */
  let payment = vm.payment = getBlankPaymentRequest()

  /**
   * Object with extra devices, which we want to exclude from subscription
   * Updated in vm.selectMainSubscription() function after main subscription selected
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCommonSubscriptionCtrl
   * @type {Object}
   */
  var excludedDevices = vm.excludedDevices = new CheckUncheckDevices()

  function updateExcludedDevices () {
    if (vm.subscription) {
      excludedDevices.update(
        /* min */ 0,
        /* max */ vm.subscription.deviceAmounts.length - 1
      ).includeAll().disableAfter(Math.min(scope.devices.count(), scope.settings.ACTIVATION_DEVICE_LIMIT) - 1)
      vm.subscription.deviceAmounts.forEach((amount, index) => {
        excludedDevices[index].include = amount.amount === 0
      })
      scope.calculate()
    }
  }
  vm.changeProrateSubscription = function () {
    vm.subscr._ym('sprt' + vm.subscr.id)
    scope.calculate()
  }

  // catch event from ActivationDevicesCtrl controller, when user adds or removes slots
  $scope.$parent.$on('event:deviceSlotsAmountChanged', function () {
    updateExcludedDevices()

    // if after we remove slots we cannot add common subscription -> reset payment type
    if (!scope.can.Common_Subscription()) {
      scope.change.paymentType()
    }
  })

  /**
   * Change Publish Now
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   */
  vm.handleChangeTrial = function () {
    vm.payment.trial = !vm.payment.trial

    if (vm.payment.trial) {
      if (scope.selectedContentAddons) {
        scope.selectedContentAddons = []
      }

      if (vm.payment.addOns) {
        [...vm.payment.addOns].forEach(addon => { vm.change.removeAddOn(addon) })
      }

      if (scope.getContentAddons) {
        scope.getContentAddons(subscr.id, vm.subscription?.id).then(() => {
          if (scope.selectedContentAddons) {
            scope.selectedContentAddons = []
          }
        })
      }
    }

    scope.calculate()
  }

  /**
   * Actions on change form fields
   *
   * @memberof mwApp/subscribers.controller:ActivationPaymentsCommonSubscriptionCtrl
   * @type {Object}
   */
  vm.change = {

    /**
     * Change main subscription
     */
    mainSubscription () {
      scope.getContentAddons && scope.getContentAddons(subscr.id, vm.subscription?.id)
      payment = vm.payment = getBlankPaymentRequest({
        override: payment.override,
        trial: false,
        $adjustEnabled: false,
        $adjustType: 'SUBTRACT',
        $extraLength: 1
      })

      // update addons list
      vm.addOns = (angular.copy(accessories) || []).filter(a => a.currency.id === vm.subscription.currency.id)
      scope.selectedContentAddons = []

      // update excluded devices
      updateExcludedDevices()
      // call parent's change.mainSubscription()
      scope.change.mainSubscription(vm.subscription)
      scope.subscription = vm.subscription

      vm.payment.$adjustMax = vm.subscription.lengthType === 'Days' ? vm.subscription.length - 1 : vm.subscription.length * 30 - 1
      vm.payment.$trialAdjustMax = vm.subscription.trialLengthType === 'Days' ? vm.subscription.trialLength - 1 : vm.subscription.trialLength * 30 - 1
    },

    /**
     * Change override type
     */
    overrideFlag () {
      scope.calculate()
    },

    /**
     * Add addon to payment request
     */
    addAddOn (addon) {
      add(payment.addOns)(
        remove(vm.addOns)(addon)()[0]
      )()
      vm.addon = undefined
      scope.calculate()
    },

    /**
     * Remove addons from payment request
     */
    removeAddOn (addon) {
      add(vm.addOns)(
        remove(payment.addOns)(addon)()[0]
      )()
      scope.calculate()
    }
  }

  /*
   * Get part of payment from child view
   */
  scope.getChildPayment = () =>
    vm.subscription
      ? {
        ...payment,
        contentSetAddOns: scope.selectedContentAddons || [],
        devicesToPay: 1 + excludedDevices.count(),
        subscriptionId: vm.subscription?.id,
        accessoryIds: payment.addOns.map(getId),
        trial: vm.payment.trial
      }
      : undefined
}
